import type { SxProps, Theme } from '@mui/material/styles';
import { registerColors } from '../../styles/colors';
import { LAYOUT } from '../../styles/layout';

export const heroStackSx: SxProps<Theme> = {
  overflow: 'hidden',
  '@media (min-width:1536px)': { width: LAYOUT.heroWidthLarge },
  '@media (max-width:1023px)': { display: 'none' },
};

export const formPanelSx: SxProps<Theme> = {
  py: 'clamp(16px, 3vw, 5%)',
  px: 'clamp(32px, 8vw, 14%)',
  backgroundColor: registerColors.backgroundPanel,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  opacity: 1,
  position: 'relative',
  zIndex: 0,
  '@media (min-width:1536px)': { width: LAYOUT.formWidthLarge },
  '@media (max-height: 750px)': { overflowY: 'auto', justifyContent: 'flex-start' },
  '@media (max-width:1023px)': {
    width: '100%',
    py: 'clamp(16px, 4vw, 40px)',
    px: 'clamp(16px, 6vw, 48px)',
  },
};
